/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveMetaPoolLike,
  ICurveMetaPoolLikeInterface,
} from "../ICurveMetaPoolLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "int128",
        name: "i",
        type: "int128",
      },
      {
        internalType: "int128",
        name: "j",
        type: "int128",
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minDy",
        type: "uint256",
      },
    ],
    name: "exchange_underlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int128",
        name: "i",
        type: "int128",
      },
      {
        internalType: "int128",
        name: "j",
        type: "int128",
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256",
      },
    ],
    name: "get_dy_underlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveMetaPoolLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveMetaPoolLikeInterface {
    return new utils.Interface(_abi) as ICurveMetaPoolLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveMetaPoolLike {
    return new Contract(address, _abi, signerOrProvider) as ICurveMetaPoolLike;
  }
}
